import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    markSheetSubjectEmployees: [],
    loadingMarkSheetSubjectEmployees: false,

    employees: [],
    loadingEmployees: false
};

////////////////////////////////////////////////////////////////

const loadMarkSheetSubjectEmployees = (state) => {
    return {
        ...state,
        loadingMarkSheetSubjectEmployees: true
    }
}

const resetMarkSheetSubjectEmployees = (state) => {
    return {
        ...state,
        loadingMarkSheetSubjectEmployees: false,
        markSheetSubjectEmployees: []
    }
}

const setMarkSheetSubjectEmployees = ( state, action ) => {
    let tmp = [...action.markSheetSubjectEmployees]
    return {
        ...state,
        markSheetSubjectEmployees: tmp,
        loadingMarkSheetSubjectEmployees: false
    }
}

////////////////////////////////////////////////////////////////

const loadEmployees = (state) => {
    return {
        ...state,
        loadingEmployees: true
    }
}

const resetEmployees = (state) => {
    return {
        ...state,
        loadingEmployees: false,
        employees: []
    }
}

const setEmployees = ( state, action ) => {
    let tmp = [...action.employees]
    return {
        ...state,
        employees: tmp,
        loadingEmployees: false
    }
}

////////////////////////////////////////////////////////////////

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_MARK_SHEET_SUBJECT_EMPLOYEES: return loadMarkSheetSubjectEmployees( state );
        case actionTypes.RESET_MARK_SHEET_SUBJECT_EMPLOYEES: return resetMarkSheetSubjectEmployees( state );
        case actionTypes.SET_MARK_SHEET_SUBJECT_EMPLOYEES: return setMarkSheetSubjectEmployees( state, action );

        case actionTypes.LOAD_EMPLOYEES: return loadEmployees( state );
        case actionTypes.RESET_EMPLOYEES: return resetEmployees( state );
        case actionTypes.SET_EMPLOYEES_LIST: return setEmployees( state, action );

        default: return state;
    }
};
export default reducer;